import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from '../shared/styles';
import isEmpty from 'lodash/isEmpty';
import Feature from './feature';
import { RowDivision, DivisionLabel, HelperText } from '../shared/styled-components';
import Title from '../shared/Title';

class Features extends Component {
  constructor(props) {
    super(props);

    this.state = {
      features: [],
      focusIndex: 0,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onInputKeyUp = this.onInputKeyUp.bind(this);
    this.onFeatureTitleChange = this.onFeatureTitleChange.bind(this);
    this.onFeatureInputChange = this.onFeatureInputChange.bind(this);
    this.onFeatureInputDelete = this.onFeatureInputDelete.bind(this);
    this.onFeatureAdd = this.onFeatureAdd.bind(this);
  }

  componentDidMount() {
    const { list } = this.props;
    this.setState({
      features: list,
    });
  }

  onInputChange() {
    const { onChange } = this.props;
    const { features } = this.state;

    // filter empty features
    onChange(
      features.filter(feature => {
        return feature !== '';
      })
    );
  }

  onInputKeyUp(e) {
    const { enableEnterAdd } = this.props;
    if (enableEnterAdd && e.key.toLowerCase() === 'enter') {
      this.onFeatureAdd();
    }
  }

  onFeatureTitleChange() {
    return e => {
      const value = e.target.value;
      const { onTitleChange } = this.props;
      onTitleChange(value);
    }
  }

  onFeatureInputChange(index) {
    return e => {
      const value = e.target.value;
      const { features } = this.state;
      features[index] = value;
      this.setState({ features }, this.onInputChange);
    };
  }

  onFeatureInputDelete(index) {
    return e => {
      const { features } = this.state;
      if (features.length >= 2) {
        features.splice(index, 1);
      } else {
        features[0] = '';
      }

      this.setState({ features }, this.onInputChange);
    };
  }

  onFeatureAdd() {
    const { features } = this.state;
    features.push('');
    const focusIndex = features.length - 1;
    this.setState({ features, focusIndex });
  }

  render() {
    const { label, helper, placeholder, onAdd, onDelete, title = '' } = this.props;
    const { features, focusIndex } = this.state;

    const helperRender = !isEmpty(helper) ? (
      <HelperText>{helper}</HelperText>
    ) : null;

    return (
      <RowDivision className="row">
        <div id="features" className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <DivisionLabel>
            {label}
            {helperRender}
          </DivisionLabel>
          <div style={styles.featuresInfoWrapper}>
            <div style={styles.featuresInfoInputDivision}>
              <div style={{ ...styles.inputLabelWrapper, fontWeight: 500 }}>
                Section Title
              </div>
              <input
                type="text"
                style={styles.inputTitle}
                placeholder={'WHAT YOU WILL GET'}
                onChange={this.onFeatureTitleChange()}
                value={title}
              />
            </div>
            <div style={styles.featuresInfoInputDivision}>
              <div style={{ ...styles.inputLabelWrapper, fontWeight: 500, margin: 0 }}>
                Feature List
              </div>
            </div>

            {features.map((feature, index) => {
              return (
                <Feature
                  key={`feature=${index}`}
                  prefix={index + 1}
                  willFocus={focusIndex === index && index !== 0}
                  value={feature}
                  placeholder={placeholder}
                  onInputChange={this.onFeatureInputChange(index)}
                  onInputKeyUp={this.onInputKeyUp}
                  onDelete={this.onFeatureInputDelete(index)}
                />
              );
            })}

            <button style={styles.addFeatureButton} onClick={this.onFeatureAdd}>
              Add Feature
            </button>
          </div>
        </div>
      </RowDivision>
    );
  }
}

Features.propTypes = {
  label: PropTypes.string,
  list: PropTypes.array,
  helper: PropTypes.string,
  placeholder: PropTypes.string,
  list: PropTypes.array,
  onChange: PropTypes.func,
  onTitleChange: PropTypes.func,
  enableEnterAdd: PropTypes.bool,
};

Features.defaultProps = {
  label: 'Features',
  list: [],
  helper: '',
  placeholder: '',
  list: [],
  onChange: () => {},
  onTitleChange: () => {},
  enableEnterAdd: false,
};

export default Features;
